import React from "react";
import { toast } from "sonner";
import { ShareNetwork, Copy, WhatsappLogo, ArrowSquareOut } from "@phosphor-icons/react";
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuLabel } from "@/components/ui/dropdown-menu";

const copyText = async (t) => {
  try { await navigator.clipboard.writeText(t); }
  catch (e) {
    const ta = document.createElement("textarea"); ta.value = t; document.body.appendChild(ta); ta.select();
    document.execCommand("copy"); ta.remove();
  }
};

export const ShareLandingMenu = ({ business }) => {
  const url = business.landing_short_url || `${window.location.origin}/products`;
  const msg = `${business.landing_share_text || "Our security cameras:"} ${url}`.trim();
  const copy = async () => { await copyText(url); toast.success(`Copied ${url}`); };
  const siteUrl = `${window.location.origin}/site`;
  const siteMsg = `Armstrong Private Security Ltd — alarms, cameras and security in Paphos: ${siteUrl}`;
  const copySite = async () => { await copyText(siteUrl); toast.success(`Copied ${siteUrl}`); };
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center justify-center w-11 h-11 text-slate-300 hover:bg-white/10 hover:text-white transition-colors shrink-0" title="Share camera page or website" data-testid="share-landing-btn">
          <ShareNetwork size={22} weight="duotone" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64 rounded-none">
        <DropdownMenuLabel className="text-xs uppercase tracking-wider">Camera page</DropdownMenuLabel>
        <div className="px-2 pb-1.5 text-xs text-muted-foreground truncate" data-testid="share-landing-url">{url}</div>
        <DropdownMenuItem onClick={copy} data-testid="share-landing-copy"><Copy size={18} className="mr-2" /> Copy link</DropdownMenuItem>
        <DropdownMenuItem onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, "_blank", "noopener")} data-testid="share-landing-whatsapp">
          <WhatsappLogo size={18} weight="fill" className="mr-2 text-green-600" /> Send on WhatsApp
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => window.open(url, "_blank", "noopener")} data-testid="share-landing-open"><ArrowSquareOut size={18} className="mr-2" /> Open landing page</DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-xs uppercase tracking-wider">Main website</DropdownMenuLabel>
        <div className="px-2 pb-1.5 text-xs text-muted-foreground truncate" data-testid="share-site-url">{siteUrl}</div>
        <DropdownMenuItem onClick={copySite} data-testid="share-site-copy"><Copy size={18} className="mr-2" /> Copy website link</DropdownMenuItem>
        <DropdownMenuItem onClick={() => window.open(`https://wa.me/?text=${encodeURIComponent(siteMsg)}`, "_blank", "noopener")} data-testid="share-site-whatsapp">
          <WhatsappLogo size={18} weight="fill" className="mr-2 text-green-600" /> Send website on WhatsApp
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => window.open(siteUrl, "_blank", "noopener")} data-testid="share-site-open"><ArrowSquareOut size={18} className="mr-2" /> Open website</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
